import script from "./forms.vue?vue&type=script&setup=true&lang=js"
export * from "./forms.vue?vue&type=script&setup=true&lang=js"

import "./forms.vue?vue&type=style&index=0&id=de9ad9be&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de9ad9be"]])

export default __exports__